// survey configuration service
export default {
  install: (Vue) => {
    //private
    const route = process.env.VUE_APP_API_BASE_URL + '/api/survey-configuration';

    //public
    Vue.$surveyConfigurationService = {
      find(params) {
        return Vue.axios.get(route, {
          params: params
        });
      }
    };
  }
};
